import {
  Breadcrumb,
  PageHeader,
  Table,
  Tooltip,
  Typography,
  message,
  Statistic,
  Row,
  Col,
  Card,
  Button,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import {
  reportService,
  companyService,
  materialTypeService,
  stockClassificationService,
} from "_services";
import { Auth } from "_helpers";
import { FileExcelOutlined } from "@ant-design/icons";
import StocksAgingSearch from "./StocksAgingSearch";

/* const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
}); */

const StocksAging = () => {
  const [loading, setLoading] = useState(false);
  const [isLoadingStoreAddresses, setIsLoadingStoreAddresses] = useState(false);
  const [isLoadingStockTypes, setIsLoadingStockTypes] = useState(false);
  const [isLoadingStockClassifications, setIsLoadingStockClassifications] =
    useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [dateFilter, setDateFilter] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [stockTypes, setStockTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);
  const [items, setItems] = useState([]);
  const [stockTotal, setStockTotal] = useState(null);
  const [searchQuery, setSearchQuery] = useState([]);
  const { Title } = Typography;
  const precision = 3;

  useEffect(() => {
    getStoreLocations();
    getStockTypes();
    getStockClassifications();
  }, []);

  const getStoreLocations = () => {
    setIsLoadingStoreAddresses(true);
    companyService
      .getSuggestion("?companyTypeCodes=STORE")
      .then((x) => {
        setIsLoadingStoreAddresses(false);
        if (x.content && x.content.length === 1) {
          setIsLoadingStoreAddresses(true);
          companyService
            .getById(x.content[0].id)
            .then((x) => {
              setIsLoadingStoreAddresses(false);
              setAddresses(x.content.addresses);
              if (x.content.addresses.length === 1) {
                getItems(x.content.addresses[0].id);
              }
            })
            .catch((errorInfo) => {
              setIsLoadingStoreAddresses(false);
            });
        }
      })
      .catch((errorInfo) => {
        setIsLoadingStoreAddresses(false);
        message.error(`${errorInfo}`);
      });
  };

  const getStockTypes = () => {
    setIsLoadingStockTypes(true);
    materialTypeService
      .getSuggestion()
      .then((x) => {
        setIsLoadingStockTypes(false);
        setStockTypes(x.content);
      })
      .catch((error) => {
        setIsLoadingStockTypes(false);
        message.error(`${error}`);
      });
  };

  const getStockClassifications = () => {
    setIsLoadingStockClassifications(true);
    stockClassificationService
      .getSuggestion()
      .then((x) => {
        setIsLoadingStockClassifications(false);
        setStockClasses(x.content);
      })
      .catch((errorInfo) => {
        setIsLoadingStockClassifications(false);
        message.error(`${errorInfo}`);
      });
  };

  const getItems = (storeLocationIds) => {
    setLoading(true);
    let searchParams = "";
    searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
    searchParams += `fromDate=${encodeURIComponent(
      moment("2021-01-01").format("YYYY-MM-DD")
    )}&toDate=${moment().format(
      "YYYY-MM-DD"
    )}&storeLocations=${storeLocationIds}`;
    setSearchQuery(searchParams);
    reportService
      .getAvailableStocksByView(searchParams)
      .then((data) => {
        if (data.content.length > 0) {
          let index = 0;
          data.content.forEach((item) => {
            item.key = index++;
          });
          setItems(data.content);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSearchResults = (
    results,
    fromDate,
    toDate,
    isFilterEnabled,
    searchParams
  ) => {
    setItems(results);
    setFromDate(fromDate);
    setToDate(toDate);
    setDateFilter(isFilterEnabled);
    setSearchQuery(searchParams);
    setLoading(false);
  };

  const handleSearchResultTotal = (resultTotal) => {
    setStockTotal(resultTotal);
  };

  const handleExportExcel = () => {
    setLoadingExcel(true);
    reportService
      .exportStocksAgingExcel(searchQuery)
      .then((response) => {
        const url = window.webkitURL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Stocks-Aging-Report_${moment(new Date()).format("YYYY-MM-DD")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoadingExcel(false);
      })
      .catch((error) => {
        setLoadingExcel(false);
        message.error(error);
      });
  };

  const getColumns = () => {
    const columns = [];
    columns.push({
      title: "Description",
      key: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockTypeName}>
            {record.stockTypeName}
          </Tooltip>
        );
      },
    });

    columns.push({
      title: "Total Age",
      dataIndex: "totalAge",
      key: "totalAge",
      align: "left",
    });

    columns.push({
      title: "Total Items",
      dataIndex: "totalItems",
      key: "totalItems",
      align: "left",
    });

    return columns;
  };

  return (
    <>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/reports">Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Stocks Aging</Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        <Page inner>
          <>
            <StocksAgingSearch
              showSearchLoading={setLoading}
              onSearchResults={handleSearchResults}
              onSearchResultTotal={handleSearchResultTotal}
              addresses={addresses}
              stockTypes={stockTypes}
              stockClasses={stockClasses}
              loadingStoreAddress={isLoadingStoreAddresses}
              loadingStockTypes={isLoadingStockTypes}
              loadingStockClassification={isLoadingStockClassifications}
            />
            {!dateFilter && (
              <Title level={5} style={{ marginTop: 20 }}>
                As of: {moment().format("YYYY-MM-DD")}
              </Title>
            )}
            {dateFilter && (
              <Title level={5} style={{ marginTop: 20 }}>
                As of: From:{moment(fromDate).format("YYYY-MM-DD")} - To:
                {moment(toDate).format("YYYY-MM-DD")}
              </Title>
            )}
            {items && items.length > 0 && (
              <div
                style={{
                  background: "#ECECEC",
                  padding: "15px",
                  marginBottom: 15,
                }}
              >
                <Row gutter={24}>
                  {/* <Col span={6}>
                    <Card>
                      <Statistic
                        title="Total Pallets"
                        value={stockTotal && stockTotal.totalPallets}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col> */}
                  <Col span={6}>
                    <Card>
                      <Statistic
                        title="Total Items"
                        value={stockTotal && stockTotal.totalItems}
                        valueStyle={{ color: "#3f8600" }}
                      />
                    </Card>
                  </Col>
                  <Col span={6}></Col>
                  <Col span={9}></Col>
                  <Col span={3}>
                    <Button
                      type="primary"
                      onClick={handleExportExcel}
                      style={{
                        marginBottom: 20,
                      }}
                      icon={<FileExcelOutlined />}
                      loading={loadingExcel}
                    >
                      Export to Excel
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            <Table
              bordered
              loading={loading}
              size="small"
              columns={getColumns()}
              dataSource={items}
              pagination={false}
              summary={(pageData) => {
                let totalPallets = 0;
                let totalAges = 0;

                pageData.forEach(({ totalItems,totalAge }) => {
                  totalPallets += totalItems;
                  totalAges += totalAge;
                });



                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell colSpan={1}>
                        <Typography.Text strong>Total</Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="left">
                        <Typography.Text strong>{totalAges}</Typography.Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell align="left">
                        <Typography.Text strong>{totalPallets}</Typography.Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </>
        </Page>
      </PageHeader>
    </>
  );
};

export default StocksAging;
